(function () {
  'use strict';
  if (window.SBlockFeedback) return;

  function newId() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    var bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.prototype.map.call(bytes, function (b) { return b.toString(16).padStart(2, '0'); }).join('');
  }

  function isSaved(result) {
    return Boolean(result && result.success === true && Number.isInteger(result.row) && result.row >= 2);
  }

  async function sendIssue(endpoint, payload) {
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, 45000);
    try {
      var response = await fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        body: payload,
        signal: controller.signal
      });
      if (!response.ok) throw new Error('Save not confirmed');
      var result = await response.json();
      if (!isSaved(result) || result.sessionId !== payload.get('Session ID')) {
        throw new Error('Save not confirmed');
      }
      return result;
    } finally {
      window.clearTimeout(timer);
    }
  }

  function sendUninstall(endpoint, payload) {
    var body = new URLSearchParams();
    Object.keys(payload).forEach(function (key) { body.append(key, payload[key]); });
    body.append('source', 'uninstall');
    body.append('Session ID', payload.sessionId);
    return sendIssue(endpoint, body);
  }

  function lockForm(form) {
    var fields = Array.prototype.map.call(form.querySelectorAll('input, textarea, select, button'), function (field) {
      var previous = field.disabled;
      field.disabled = true;
      return { field: field, disabled: previous };
    });
    return function () {
      fields.forEach(function (item) { item.field.disabled = item.disabled; });
    };
  }

  window.SBlockFeedback = { newId: newId, sendIssue: sendIssue, sendUninstall: sendUninstall, lockForm: lockForm };
})();
